// extracted by mini-css-extract-plugin
module.exports = {"tooltip-content__title":"yA9wq","tooltipContentTitle":"yA9wq","tooltip-content__link":"T3aX3","tooltipContentLink":"T3aX3"};